import type { ReactNode } from 'react';
import { Box, Card, Container, Group, Stack, Text } from '@mantine/core';
import { IconPackage } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '../../shared/i18n/LanguageSwitcher';
import { AppFooter } from '../../app/AppFooter';

interface Props {
  children: ReactNode;
}

/**
 * Shared chrome for the authentication screens (login, and later
 * forgot-password / MFA-enrollment). Mirrors RegistrationLayout — same brand
 * mark, language switcher, and white card — without the "step N of 3" pill,
 * since auth is not a wizard.
 */
export function AuthLayout({ children }: Props) {
  const { t } = useTranslation();
  return (
    <Box mih="100vh" bg="var(--mantine-color-gray-0)" py="xl">
      <Container size={420}>
        <Stack gap="lg">
          <Group justify="space-between" align="flex-end">
            <Group gap="sm" align="center">
              <Box
                w={32}
                h={32}
                style={{
                  borderRadius: 8,
                  background: 'var(--mantine-color-invetrak-1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <IconPackage size={18} color="var(--mantine-color-invetrak-7)" />
              </Box>
              <Text fw={600} size="md">{t('app.name')}</Text>
            </Group>
            <LanguageSwitcher />
          </Group>

          <Card withBorder radius="md" padding="xl" shadow="none">
            {children}
          </Card>
        </Stack>
      </Container>

      <AppFooter variant="transparent" />
    </Box>
  );
}
